/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_DecInputs */

const en_better_studio_month_dec = /** @type {(inputs: Better_Studio_Month_DecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dec`)
};

/**
* | output |
* | --- |
* | "Dec" |
*
* @param {Better_Studio_Month_DecInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_dec = /** @type {((inputs?: Better_Studio_Month_DecInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_DecInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_dec(inputs)
});